import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme)=> ({
    container: {
        border: `1px solid ${theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[400]}`,
        borderRadius: '4px',
        padding: theme.spacing(0.5),
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap'
    },
    chip: {
        borderRadius: '4px',
        width: `calc(50% - ${theme.spacing(0.25)})`,
        marginBottom: theme.spacing(0.5),
        borderColor: 'transparent',
        cursor: 'pointer',
        '&:last-child': {
            marginBottom: 0
        },
        '&:nth-last-of-type(2)': {
            marginBottom: 0
        }
    }
}))